// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/img_404.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-size: 0.24rem;
}
.error-icon {
  display: block;
  width: 2.04rem;
  height: 0.84rem;
  background-size: contain;
  margin: 0 auto 0.32rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.error-msg {
  font-size: 0.28rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.less"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;AAGC;EACC,cAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AADF;AAIC;EACC,kBAAA;AAFF","sourcesContent":["body {\n\tfont-size: 12px;\n}\n\n.error {\n\t&-icon {\n\t\tdisplay: block;\n\t\twidth: 102px;\n\t\theight: 42px;\n\t\tbackground-size: contain;\n\t\tmargin: 0 auto 16px;\n\t\tbackground-image: url(./assets/images/img_404.png);\n\t\tbackground-size: cover;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: center;\n\t}\n\n\t&-msg {\n\t\tfont-size: 14px;\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
